/*** THIS CLASS WILL REPLACE CONTENT GRID 1 AND HOPEFULLY BE USED BY TOP CONTENTS AND MOST RETWEETED WIDGETS */
// **************************************************************************************************************************
// **************************************************************************************************************************
// **************************************************************************************************************************
// **************************************************************************************************************************

import { CSVTranformationProfile, CSVProfile } from '../../types'
import { BaseVisualization } from '../base/base-visualization-component'
import _ from 'lodash';
import { TRANSFORM_MILLI_TO_DATE, TRANSFORM_SENTIMENTS_TO_WORDS } from '../commons/constants';
import { ContentDocumentTwitterAdapter } from '../service/twitter-content-document'

export class ContentGridComponent2 extends BaseVisualization {
    static config = {
        selector: 'contentGridComponent2',
        controller: ContentGridComponent2,
        template: `
            <div class="af__content__container" id="documentDiv">
                <div class="af__content__item" ng-repeat="contentDocument in $ctrl.contentDocuments">
                    <mw-media-document
                        document="contentDocument.json"
                        display-mode="$ctrl.displayMode"
                        is-selectable="$ctrl.displaySettings.isSelectable"
                        is-avatar-visible="$ctrl.displaySettings.isAvatarVisible"
                        is-avatar-padding-on="$ctrl.displaySettings.isAvatarPaddingOn"
                        is-title-visible="$ctrl.displaySettings.isTitleTextVisible"
                        is-ingress-visible="$ctrl.displaySettings.isIngressVisible"
                        is-match-sentence-visible="$ctrl.displaySettings.isMatchSentenceVisible"
                        is-media-visible="$ctrl.displaySettings.isMediaVisible"
                        is-media-placeholder-visible="$ctrl.displaySettings.isMediaPlaceholderVisible"
                        media-emphasis="$ctrl.displaySettings.mediaEmphasis"
                        is-keywords-visible="$ctrl.displaySettings.isKeywordsVisible"
                        is-tags-visible="$ctrl.displaySettings.isTagsVisible"
                        is-reach-visible="$ctrl.displaySettings.isReachVisible"
                        is-duplicates-visible="$ctrl.displaySettings.isDuplicatesVisible"
                        is-sentiment-visible="$ctrl.displaySettings.isSentimentVisible"
                        is-fixed-media-aspect-ratio="$ctrl.displaySettings.isFixedMediaAspectRatio"
                        is-blur-enabled="$ctrl.displaySettings.isBlurEnabled"
                        is-inline-sentiment-enabled="$ctrl.displaySettings.inlineSentiment"
                        is-social-echo-visible="$ctrl.displaySettings.isSocialEchoVisible"
                        is-social-engagement-visible="$ctrl.displaySettings.isSocialEngagementVisible"
                        on-select-toggle="$ctrl.toggleDocumentSelection($event.document)"
                        on-sentiment-update="$ctrl.handleSentimentUpdate($event.document, $event.sentiment)"
                        on-sentiment-reset="$ctrl.handleSentimentReset($event.document)"
                        on-tag-removal="$ctrl.handleTagRemoval($event.document, $event.tag)"
                        on-title-click="$ctrl.handleHostedContentClick($event)"
                        on-timestamp-click="$ctrl.handleHostedContentClick($event)"
                        on-avatar-click="$ctrl.handleHostedContentClick($event)"
                        timezone="$ctrl.demosTimezoneService.timezone"
                        active-tray-content="$ctrl.activeTrayContent"
                        is-document-clickable="$ctrl.displaySettings.isDocumentClickable"
                        on-document-click="$ctrl.toggleDocumentSelection($event.document)"
                        >
                    <mw-content-document-footer ng-if="$ctrl.componentSettings.showCustomFooter">
                        <div style="display: flex; padding-top: 18px;">
                            <div ng-if="contentDocument.json.reachCount !== null" style="width: 29%; margin-right: auto;">
                                <span>{{contentDocument.json.reachCount | mwUsNumberSystem}}</span>
                                <span translate style="padding-left: 2px;"> Reach </span>
                            </div>
                            <span style="margin-left: auto;" ng-if="$ctrl.valueType !== 'mostEngagedContent'"> {{contentDocument.value | mwUsNumberSystem}} {{'social_engagement--retweets' | translate }} </span>
                            <span style="margin-left: auto;" ng-if="$ctrl.valueType === 'mostEngagedContent'"> {{contentDocument.value | mwUsNumberSystem}} {{'Engagement' | translate }} </span>

                        </div>
                    </mw-content-document-footer>
                    </mw-media-document>
                    <mw-content-document-placeholder
                        ng-if="$ctrl.isLoading"
                        is-selectable="$ctrl.displaySettings.isSelectable"
                        display-mode="$ctrl.displayMode"
                        >
                    </mw-content-document-placeholder>
                </div>
            </div>


        `,
        bindings: BaseVisualization.config.bindings,
    }

    public mediaType = 'twitter';

    public displayMode = 'indy'

    public displaySettings = {
        isDocumentClickable: false,
        isSelectable: false,
        isAvatarVisible: true,
        isAvatarPaddingOn: false,
        isTitleTextVisible: true,
        isFixedMediaAspectRatio: true,
        isBlurEnabled: true,
        isIngressVisible: true,
        isMatchSentenceVisible: true,
        isMediaVisible: true,
        isMediaPlaceholderVisible: false,
        isKeywordsVisible: false,
        isKeywordsClickable: false,
        isTagsVisible: true,
        isDuplicatesVisible: true,
        inlineSentiment: false,
        isReachVisible: true,
        isSentimentVisible: false,
        isSocialEchoVisible: true,
        isSocialEngagementVisible: true,
        isHosted: false,
        mediaEmphasis: 'high',
    }

    public componentSettings = {
        showTitle: false,
        showCustomFooter: false
    }

    public reactionColors = ['#F65D8B', '#1DD1A1']
    public seriesColors = [
        '#0194EB',
        '#FFBC45',
        '#F65D8B',
        '#1DD1A1',
        '#FF7845',
        '#545454',
        '#96497B',
        '#3E9189',
        '#956445',
        '#3B5C87',
    ]

    public contentDocuments = [];
    // private tmpData = [];

    // default CSV header columns. Can be overriden in sub class.
    //TODO: Ask Nick what the top content CSV export format should look like.
    public csvHeaders = ['Date', 'URL', 'Language', 'Country', 'Reach', 'MediaType', 'MatchSentence', 'Sentiment', 'Retweets', 'Author', 'Handle']

    /**
     * CSV transformation profile. Defines how csv key value transformed
     */
    public transformationProfiles: CSVTranformationProfile[] = [
        { key: 'date', type: TRANSFORM_MILLI_TO_DATE },
        { key: 'sentiment', type: TRANSFORM_SENTIMENTS_TO_WORDS, }
    ]

    public bodyTruncationLength = 200

    $onChanges(changes) {
        if (this.hasChanges(changes.visualizationMetaData)) {
            this.setMetaData(changes.visualizationMetaData.currentValue)
        }
        if (this.hasChanges(changes.vizData)) {
            //reset pagination when data is changed/updated
            this.pagination.currentPage = 0;

            this.setProperties()
            this.prepareVisualizations(changes.vizData.currentValue.data)
            this.buildCSVExportProfile()
        }

        // watch for pagination changes
        if (this.hasChanges(changes.pagination)) {
            this.prepareVisualizations(this.vizData.data)
        }
    }

    setProperties() { }

    prepareVisualizations(data) {

        let startIndex = this.pagination.currentPage * this.pagination.pageSize
        let endIndex = this.pagination.currentPage * this.pagination.pageSize + this.pagination.pageSize

        this.contentDocuments = data.all.map(e => {
            const newDoc = ContentDocumentTwitterAdapter.toContentDocument(e.json)
            return Object.assign({}, e, { json: newDoc } );

        }).slice(startIndex, endIndex)
    }

    /**
     * Build CSV export profile which includes data, options
     * and the key transformation types if any.
     */
    buildCSVExportProfile() {
        this.csvExportProfiles = []

        let exportData: CSVProfile = {
            //special case for CSV export as data is retrieved as content documents
            data: Object.assign({}, {
                all: this.vizData.data.all.map(d => {
                    let extract = this.getExportModel(d.json)
                    return Object.assign(extract, { retweets: d.value, name: _.get(d.json, 'authors[0].name'), handle: _.get(d.json, 'authors[0].handle') })
                })
            }),
            csvOptions: { title: this.visTitle, headers: this.csvHeaders },
            transformationProfiles: this.transformationProfiles,
        }

        this.csvExportProfiles.push(exportData)
    }

    getExportModel(contentDocument) {
        let model = {
            date: null,
            url: null,
            language: null,
            country: null,
            reach: null,
            mediaType: null,
            matchSentence: null,
            sentiment: null,
        }
        return _.pick(contentDocument, _.keys(model))
    }
}
